import {Clock, Phone} from 'react-bootstrap-icons';
import styles from './Header.module.scss';
import {Col, Container, Row} from "react-bootstrap";

function TopHeader() {
    return (
        <div className={styles.topHeader}>
            <Container>
                <Row className="align-items-center">
                    <Col className="d-flex align-items-center">
                        <Phone size={14} className="me-2"/>
                        <a href="tel:+79024777252" className={styles.phoneLink}>
                            8 (902) 477 72 52
                        </a>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center">
                        <Clock size={14} className="me-2"/>
                        <span>10:00-19:00 пн-сб</span>
                    </Col>
                    <Col className="text-end">
                        <span className={styles.topHeaderText}>г. Верещагино, ул. К. Маркса, 64</span>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default TopHeader;